/* ============================================================
   BRILIAX v3 — animated product landing (product template only)
   Counters, video loop enforcement. Reveal animations reuse the
   theme's existing .reveal system (theme.js).
   ============================================================ */
(function () {
  if (window.__blxLanding) return;
  window.__blxLanding = true;

  function init() {
    /* ---- Animated counters: count up when scrolled into view ---- */
    function animateCount(el) {
      var target = parseFloat(el.getAttribute('data-count'));
      if (isNaN(target)) return;
      var dur = 1500, start = null;
      function frame(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(frame);
        else el.textContent = Math.round(target);
      }
      requestAnimationFrame(frame);
    }
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { animateCount(e.target); cio.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      document.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });
    }

    /* ---- Product videos: always loop, muted autoplay ---- */
    function fixVideos(root) {
      (root || document).querySelectorAll('video').forEach(function (v) {
        v.loop = true;
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.autoplay = true;
        try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (err) {}
      });
    }
    fixVideos();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) fixVideos(n);
          });
        });
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
